import { createReducer, on } from '@ngrx/store';
import {
  getPushStatus,
  deleteCodeGeneration,
  generateBECode,
  generateBECodeStatus,
  getCodeGeneration,
  pullCodeFromGit,
  pulledCodeFromGit,
  pushCodeToGit,
  pushedCodeToGit,
  saveCodeGeneration,
  updateCodeGeneration,
  syncToGit,
  syncedToGit
} from '../actions/codegeneration.actions';
import { appGenLoader } from '../selectors/codegeneration.selector';

export interface CodeGenerationState {
  data: any;
}

export const initialState: CodeGenerationState = {
  data: {}
};

export const codeGenerationReducer = createReducer(
  initialState,
  on(getCodeGeneration, (state, { codeGenApiConstants }) => ({
    ...state,
    ...codeGenApiConstants
  })),
  on(saveCodeGeneration, (state, { codeGenerationData }) => ({
    ...state,
    ...codeGenerationData
  })),
  on(updateCodeGeneration, (state, { codeGenerationData }) => {
    return {
      ...state,
      ...codeGenerationData
    };
  }),
  on(deleteCodeGeneration, (state, { codeGenerationId }) => {
    return {
      ...state,
      codeGenerationId
    };
  }),
  on(generateBECode, (state, { genBECodeApi }) => {
    return {
      ...state,
      ...{ genBECodeApi },
      appGenLoader: true
    };
  }),
  on(generateBECodeStatus, (state, { beCodeGenStatus }) => {
    return {
      ...state,
      beCodeGenStatus: beCodeGenStatus,
      appGenLoader: false
    };
  }),
  on(pushCodeToGit, (state, { pushToGitApi }) => {
    return {
      ...state,
      ...{ pushToGitApi },
      pushing: true
    };
  }),
  on(pushedCodeToGit, (state, { gitCommitStatus }) => {
    return {
      ...state,
      gitCommitStatus: gitCommitStatus,
      pushing: false
    };
  }),
  on(pullCodeFromGit, (state, { pullFromGitApi }) => {
    return {
      ...state,
      ...{ pullFromGitApi },
      pulling: true
    };
  }),
  on(pulledCodeFromGit, (state, { gitPullStatus }) => {
    return {
      ...state,
      ...{ gitPullStatus },
      pulling: false
    };
  }),
  on(getPushStatus, (state, { gitStatusApi, gitParams }) => {
    return {
      ...state,
      ...{ gitStatusApi },
      ...{ gitParams },
      pushing: false,
      pulling: false,
      syncing: false
    };
  }),
  on(syncToGit, (state, { syncToGitApiConstants }) => {
    return {
      ...state,
      ...syncToGitApiConstants,
      syncing: true
    };
  }),
  on(syncedToGit, (state, { syncToGitStatus }) => {
    return {
      ...state,
      ...{ syncToGitStatus },
      syncing: false
    };
  })
);
